import React, { useEffect, useState } from "react";
import { Modal, Button } from "@material-ui/core";
import { IoClose  } from "react-icons/io5";
import { toast } from "react-toastify";

//assets
import loader from "../../assets/loader.svg";

//components
import FormInput from "../FormInput/FormInput";

import { createFaqCategory } from '../../services/design'

const CreateFAQCategoryModal = ({ open, closeModal }) => {
  const [busy, setBusy] = useState(false);
  const [name, setName] = useState("");

  const handleClose = () => {
    clearForm();
    closeModal();
  }

  const handleSubmit = async () => {
    try {
      setBusy(true);
      const res = await createFaqCategory({ name })
      clearForm();
      closeModal(res.data)
    } catch(e) {
      toast.error('Failed to create faq category')
    } finally {
      setBusy(false);
    }
  }

  const clearForm = () => {
    setName("");
  }

  const disabled = !(name.length)

  return (
    <Modal
      open={open}
      onClose={closeModal}
      className="flex items-center justify-center"
    >
      <div className="bg-white w-[606px] h-[300px] rounded">
        <div className="relative flex flex-row items-center justify-center py-4 border-b-[#E3E7ED] border-b">
          <h2 className="text-[#040A1D] text-[20px] font-bold m-0">Add New FAQ Category</h2>
          <button
            className="absolute ml-10 top-4 right-10"
            onClick={handleClose}
          >
            <IoClose size={30} color={'#8892A2'}/>
          </button>
        </div>  
        <div className="p-10 px-14">
          <FormInput 
            id="name"
            name="name"
            placeholder="Enter Category"
            label="Enter Category"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
          <div className="h-10"></div>
          <div className="flex flex-row items-center justify-end mt-8 space-x-4">
            <Button
              variant="outlined"
              className="capitalize"
              onClick={handleClose}
            >
              Cancel
            </Button>
            <Button
              onClick={handleSubmit}
              variant="contained"
              className={`text-white capitalize shadow-none relative ${
                disabled || busy
                  ? "bg-orange/30 cursor-not-allowed"
                  : "bg-orange cursor-pointer"
              }`}
            >
              Save Tag
              {busy && (
                <img src={loader} className="absolute w-5 animate-spin" alt=""/> 
              )}
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  )
}

export default CreateFAQCategoryModal;
